import React from 'react'
import './styles/IosSpinner.css'

function IosSpinner() {
  return (
    <div className="ios-spinner-overlay">
      <div className="ios-spinner">
        <div></div><div></div><div></div><div></div><div></div><div></div>
        <div></div><div></div><div></div><div></div><div></div><div></div>
      </div>
    </div>
  )
}

export default IosSpinner
